import { MAX_EMAIL_LEN, MAX_NAME_LEN, MAX_PHONE_LEN } from '../../../core/constants/forms';

// Shared field block for the create + edit client forms. Field-level errors
// come from ApiError.fields (TSS vite/04) and render inline under each input.

const MAX_DOCUMENT_LEN = 40;

export default function ClientFields({ form, setField, fieldError, disabled, showStatus = false }) {
    return (
        <div className="client-form__grid">
            <label className="client-form__field client-form__field--full">
                <span className="client-form__label">Nombre</span>
                <input
                    type="text"
                    value={form.name}
                    onChange={(e) => setField('name', e.target.value)}
                    maxLength={MAX_NAME_LEN}
                    disabled={disabled}
                    autoFocus
                    aria-invalid={!!fieldError('name')}
                />
                {fieldError('name') && <span className="client-form__error" role="alert">{fieldError('name')}</span>}
            </label>

            <label className="client-form__field">
                <span className="client-form__label">Documento</span>
                <input
                    type="text"
                    value={form.document}
                    onChange={(e) => setField('document', e.target.value)}
                    maxLength={MAX_DOCUMENT_LEN}
                    disabled={disabled}
                    placeholder="NIT / cédula (opcional)"
                    aria-invalid={!!fieldError('document')}
                />
                {fieldError('document') && <span className="client-form__error" role="alert">{fieldError('document')}</span>}
            </label>

            <label className="client-form__field">
                <span className="client-form__label">Teléfono</span>
                <input
                    type="tel"
                    value={form.phone}
                    onChange={(e) => setField('phone', e.target.value)}
                    maxLength={MAX_PHONE_LEN}
                    disabled={disabled}
                    placeholder="Opcional"
                    aria-invalid={!!fieldError('phone')}
                />
                {fieldError('phone') && <span className="client-form__error" role="alert">{fieldError('phone')}</span>}
            </label>

            <label className="client-form__field client-form__field--full">
                <span className="client-form__label">Correo</span>
                <input
                    type="email"
                    value={form.email}
                    onChange={(e) => setField('email', e.target.value)}
                    maxLength={MAX_EMAIL_LEN}
                    disabled={disabled}
                    placeholder="Opcional"
                    aria-invalid={!!fieldError('email')}
                />
                {fieldError('email') && <span className="client-form__error" role="alert">{fieldError('email')}</span>}
            </label>

            <label className="client-form__field client-form__field--full">
                <span className="client-form__label">Notas</span>
                <textarea
                    rows={3}
                    value={form.remarks}
                    onChange={(e) => setField('remarks', e.target.value)}
                    disabled={disabled}
                    placeholder="Opcional"
                    aria-invalid={!!fieldError('remarks')}
                />
                {fieldError('remarks') && <span className="client-form__error" role="alert">{fieldError('remarks')}</span>}
            </label>

            {showStatus && (
                <label className="client-form__field">
                    <span className="client-form__label">Estado</span>
                    <select
                        value={form.status}
                        onChange={(e) => setField('status', Number(e.target.value))}
                        disabled={disabled}
                    >
                        <option value={2}>Activo</option>
                        <option value={1}>Inactivo</option>
                    </select>
                </label>
            )}
        </div>
    );
}
